import React, { useState } from 'react';
import styles from './LoginForm.module.css';
import logo from './../../assets/logo.png'; // Ensure this path is correct
import { FaEnvelope, FaLock } from 'react-icons/fa';
import CompactNavbar from './../CompactNavbar/CompactNavbar';
import { motion } from 'framer-motion';
import { useAuth } from "../../utils/AuthContext/authcontext";
import { useNavigate, Navigate } from "react-router-dom";
import { useNotifications } from "../../utils/NotificationContext/NotificationContext";
import Button from '../ui/Button';


//import { auth } from '../../firebase/config';
import {
  GoogleAuthProvider,
  FacebookAuthProvider,
  signInWithPopup,
} from 'firebase/auth';
import {
  GoogleLoginButton,
  FacebookLoginButton,
} from 'react-social-login-buttons';

const LoginForm = ({modal, onForgotPassword, onClose, settings }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const { user, login } = useAuth();
  const { notify } = useNotifications();

  const handleSocialLogin = async (provider) => {
    try {
      //await signInWithPopup(auth, provider);
      // Redirect or perform post-login actions here
    } catch (error) {
      console.error('Social login error:', error);
    }
  };
  
  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await login(email, password);
	  if(modal == true) onClose();
      else {
		navigate("/home"); // Redirect to protected route after login
	  }
    } catch (error) {
	  notify('error', error.message)
    }
  };
  
  if(modal != true) {
	  if(user != null) {
		navigate("/home");
	  }
	  
	  if (user) {
		return <Navigate to="/home" />;
	  }
  }
  return (
    <div className={` ${modal == undefined ? styles.container : styles.containermodal }`}>
      {/* Navigation Bar */}
      {/*<nav className={` ${modal == undefined ? styles.navbar : styles.navbarmodal }`}>
        <div className={styles.logoContainer}>
          <img src={logo} alt="Logo" className={styles.logo} />
          <span className={styles.appName}>Ratio</span>
        </div>
      </nav>*/}

      <nav className={` ${modal == undefined ? styles.navbardiv : styles.navbarmodal }`}>
        <CompactNavbar  modal={false} scrollY={0} openContact={null} openLogin={null}/>
      </nav>

      {/* Login Card */}
		<motion.div
			className={styles.stepContainer}
			initial={{ opacity: 0, scale: 0.9 }}
			animate={{ opacity: 1, scale: 1 }}
			transition={{
			duration: 0.4,
			scale: { type: "spring", visualDuration: 0.4, bounce: 0.5 },}}>
      <div className={styles.card}>
        <h2 className={styles.title}>Welcome Back</h2>
        <p className={styles.subtitle}>Please enter your credentials to log in.</p>

        <form onSubmit={handleLogin} className={styles.form}>
          <div className={styles.inputGroup}>
            <FaEnvelope className={styles.icon} />
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              className={styles.input}
            />
          </div>

          <div className={styles.inputGroup}>
            <FaLock className={styles.icon} />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              className={styles.input}
            />
          </div>

          <Button type="submit" variant="primary" className={styles.loginButton}>
            Log In
          </Button>
        </form>

        <div className={styles.footer}>
          <Button variant="ghost" className={styles.linkButton} onClick={() => {onForgotPassword != null ? onForgotPassword() : navigate('/forgot-password')}}>
            Forgot Password?
          </Button>
          <Button variant="ghost" className={styles.linkButton} onClick={() => navigate('/register', {state: {settings}})}>
            Create an Account
          </Button>
        </div>
		
        {/* Horizontal Separator */}
        <div className={styles.separator}>
          <span className={styles.separatorText}>OR</span>
        </div>

      <div className={styles.socialLogin}>
        <GoogleLoginButton className={styles.socialLoginP} onClick={() => handleSocialLogin(new GoogleAuthProvider())} />
        <FacebookLoginButton className={styles.socialLoginP} onClick={() => handleSocialLogin(new FacebookAuthProvider())} />
        {/* Add more providers as needed */}
      </div>
      </div>
	   </motion.div>
    </div>
  );
};

export default LoginForm;

